import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';
import { useWorkspace } from '@/contexts/workspace-context';
import { UserRole } from '@optidev/shared-types';

interface UnauthorizedApiKeyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function UnauthorizedApiKeyModal({ isOpen, onClose }: UnauthorizedApiKeyModalProps) {
  const { activeWorkspace } = useWorkspace();
  const isAdmin = activeWorkspace?.role === UserRole.ADMIN;

  const handleGoToSettings = () => {
    onClose();
    window.location.href = '/dashboard/settings?tab=integration';
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[450px] w-full max-w-[90vw] rounded-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldAlert className="h-5 w-5 text-yellow-500" />
            Permission Denied
          </DialogTitle>
          <DialogDescription>
            {isAdmin
              ? "An API key is required to publish to OptiSigns."
              : "This feature requires workspace API key access."}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {isAdmin ? (
            <p className="text-sm text-muted-foreground">
              Generate a workspace API key in Settings to enable OptiSigns publishing.
            </p>
          ) : (
            <p className="text-sm text-muted-foreground">
              Please contact your workspace administrator to generate an API key.
            </p>
          )}

          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={onClose}>
              Close
            </Button>
            {isAdmin && (
              <Button onClick={handleGoToSettings}>
                Go to Settings
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
